// Status shapes and menu glyphs, one stroke weight. Status icons differ in *shape* as well
// as colour (research rule 13): circle = accepted, triangle = attention, octagon = rejected.

export type IconName = "ok" | "warn" | "bad" | "scan" | "pallet" | "bin" | "putaway" | "gear" | "camera" | "test" | "chev" | "back" | "keyboard";

export function Icon({ name, size = 24, className }: { name: IconName; size?: number | undefined; className?: string | undefined }) {
  const common = { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeLinecap: "round" as const, strokeLinejoin: "round" as const, className, "aria-hidden": true };
  switch (name) {
    case "keyboard":
      return (
        <svg {...common} strokeWidth={2}>
          <rect x="2.5" y="6" width="19" height="12" rx="2" />
          <path d="M6 10h.01M9.5 10h.01M13 10h.01M16.5 10h.01M6 13.5h.01M16.5 13.5h.01M9 14h6" strokeWidth={2.4} />
        </svg>
      );
    case "ok":
      return (
        <svg {...common} strokeWidth={2.2}>
          <circle cx="12" cy="12" r="10" />
          <path d="M7.5 12.5l3 3 6-7" strokeWidth={2.6} />
        </svg>
      );
    case "warn":
      return (
        <svg {...common} strokeWidth={2.2}>
          <path d="M12 3.5L21.5 20h-19z" />
          <path d="M12 10v4.5" strokeWidth={2.6} />
          <circle cx="12" cy="17.3" r="1.4" fill="currentColor" stroke="none" />
        </svg>
      );
    case "bad":
      return (
        <svg {...common} strokeWidth={2.2}>
          <path d="M8 2.5h8l5.5 5.5v8L16 21.5H8L2.5 16V8z" />
          <path d="M9 9l6 6M15 9l-6 6" strokeWidth={2.6} />
        </svg>
      );
    case "scan":
      return (
        <svg {...common} strokeWidth={2}>
          <path d="M3 7V4h3M18 4h3v3M21 17v3h-3M6 20H3v-3" />
          <path d="M7 8v8M10 8v8M12.5 8v8M15.5 8v8M17 8v8" strokeWidth={1.6} />
        </svg>
      );
    case "pallet":
      return (
        <svg {...common} strokeWidth={2}>
          <rect x="3" y="5" width="18" height="7" rx="1" />
          <rect x="3" y="14" width="18" height="3" rx="0.8" />
          <path d="M6 17v3M18 17v3M12 17v3" />
        </svg>
      );
    case "bin":
      return (
        <svg {...common} strokeWidth={2}>
          <path d="M4 6h16v13H4z" />
          <path d="M4 10.5h16M4 15h16M12 6v13" strokeWidth={1.5} />
        </svg>
      );
    case "putaway":
      return (
        <svg {...common} strokeWidth={2.2}>
          <path d="M12 3v10M8 9l4 4 4-4" />
          <path d="M4 16h16v4H4z" strokeWidth={2} />
        </svg>
      );
    case "gear":
      return (
        <svg {...common} strokeWidth={2}>
          <circle cx="12" cy="12" r="3.5" />
          <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1" />
        </svg>
      );
    case "camera":
      return (
        <svg {...common} strokeWidth={2}>
          <path d="M4 8h3l2-2.5h6L17 8h3v11H4z" />
          <circle cx="12" cy="13" r="3.2" />
        </svg>
      );
    case "test":
      return (
        <svg {...common} strokeWidth={2}>
          <path d="M4 5h16v14H4z" />
          <path d="M8 9v6M11 9v6M13.5 9v6M16 9v6" strokeWidth={1.6} />
        </svg>
      );
    case "chev":
      return (
        <svg {...common} strokeWidth={2.4}>
          <path d="M9 5l7 7-7 7" />
        </svg>
      );
    case "back":
      return (
        <svg {...common} strokeWidth={2.4}>
          <path d="M15 5l-7 7 7 7" />
        </svg>
      );
  }
}
